import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

export function usePrompt(message: string, when: boolean) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (when) {
        e.preventDefault();
        e.returnValue = ""; // Mensagem padrão do navegador
      }
    };

    const handleRouteChange = (e: PopStateEvent) => {
      if (when) {
        e.preventDefault(); // Previne a navegação padrão

        Swal.fire({
          title: "Você realmente quer sair?",
          text: message,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, sair",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            // Permite a navegação
            navigate(-1); // Vai para a página anterior
          } else {
            // Cancela a navegação
            navigate(location.pathname, { replace: true });
          }
        });
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handleRouteChange);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, [message, when, navigate, location]);
}
